export const SHOW_TOP_BAR = "SHOW_TOP_BAR";
export const HIDE_TOP_BAR = "HIDE_TOP_BAR";

export const SHOW_BOTTOM_BAR = "SHOW_BOTTOM_BAR";
export const HIDE_BOTTOM_BAR = "HIDE_BOTTOM_BAR";

export const SHOW_SUB_NAV_BAR = "SHOW_SUB_NAV_BAR";
export const HIDE_SUB_NAV_BAR = "HIDE_SUB_NAV_BAR";
